import React, { FC, useState, useEffect, useContext } from 'react'
import MiazgaLogo from '../../../assets/REDESIGN_Assets/LoginScreen/miazga-logo.png'
import { isMobile, isTablet } from 'react-device-detect'
import { loadStripe } from '@stripe/stripe-js'
import { useLocation } from "react-router-dom"


import GenericBackgroundLayer from '../../../GenericComponents/GenericBackgroundLayer'
import GenericColumn from '../../../GenericComponents/GenericColumn'
import GenericLogo from '../../../GenericComponents/GenericLogo'
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import Exclaimation from "../../../assets/REDESIGN_Assets/SelectSubscriptionScreen/exclaimation-mark.svg"

import { PurchaseOptionBox } from '../style'
import GenericIcon from '../../../GenericComponents/GenericIcon'
import GenericButton from '../../../GenericComponents/GenericButton'

import { generateChallengesStripeSession, getProductData } from '../../../Api/challengesApi'

interface ChallengePurchaseInterface { }

const ChallengePurchase: FC<ChallengePurchaseInterface> = ({ }) => {

  const [productData, setProductData] = useState<any>()
  const location = useLocation()

  useEffect(() => {
    handleGetProduct()
  }, [])


  const handleGetProduct = async () => {

    const product: any = await getProductData(location.state && location.state.productId)

    setProductData(product && product.stripe_product)


  }
  // live key: pk_live_51HWIlKBTktKoxCSowkBlpu6Hi3xDfKw7pkBjY71yLumHOpmpMZrvPKs3ZUdvq88bL5tiseSFo06dQm204yOZX8Mv003RH2NA19
  // test key: pk_test_51HWIlKBTktKoxCSoRq4oFh4PhDfrONqBfPhFRgorC9ytJ1BKCR13qFchCAJH47CDEg1IjQblrKgw4remQuDbuVZq00CowkNkLh

  const handleCreateStripeSession = async (id: number) => {

    const stripePromise = await loadStripe(
      'pk_live_51HWIlKBTktKoxCSowkBlpu6Hi3xDfKw7pkBjY71yLumHOpmpMZrvPKs3ZUdvq88bL5tiseSFo06dQm204yOZX8Mv003RH2NA19'
    )

    let response: any

    response = await generateChallengesStripeSession(id)

    const sessionId = response && (await response.id)

    const stripe = await stripePromise

    if (sessionId) {
      const { error } = await stripe.redirectToCheckout({
        sessionId: sessionId,
      })
    }

  }


  return (
    <GenericBackgroundLayer
      fDir={'column'}
      justify={'flex-start'}
      align={'center'}
      className="standard chose-ver"

    >
      <GenericRow margin="3% 0 0 0">
        <GenericLogo />
      </GenericRow>

      <GenericRow margin="3% 0 0 0">
        <GenericTextSpan fSize="2rem">
          Wykup wybrany pakiet
        </GenericTextSpan>
      </GenericRow>

      <GenericColumn width={isMobile ? "90%" : "50%"} margin={isMobile ? "8% 0 0 0" : "5% 0 0 0"}>

        <PurchaseOptionBox className={`${isTablet && "tablet-view"}`}>
          {/* Row 1: columns with name and price currency */}
          <GenericRow align={isMobile ? "flex-end" : "flex-start"}>
            <GenericColumn width={isMobile ? "90%" : "50%"} justify="flex-start" tAlign="left">
              <GenericTextSpan width="100%" fWeight="800" tAlign="left" fSize={isMobile ? "1.4rem" : "2rem"}>
                {`Wyzwanie ${productData && productData.name && productData.name} + PANEL DIET`}
              </GenericTextSpan>
            </GenericColumn>
            <GenericColumn width="50%" justify="flex-start" tAlign="right" align="end">
              <GenericTextSpan color="#a1ff68" fSize="1.4rem" tAlign="right">
                zł
              </GenericTextSpan>
              <GenericTextSpan color="#a1ff68" fSize={isMobile ? "3rem" : "4.5rem"} tAlign="right">
                {`${productData && productData.price && productData.price.price}`}
              </GenericTextSpan>
            </GenericColumn>
          </GenericRow>

          {/* Row 2: columns with infos about purchase option */}
          <GenericRow margin={" 5% 0 0 0"} flexDir="column" align="flex-start" wrap="wrap" justify="flex-start">
            <GenericColumn width={isMobile ? "100%" : "40%"} margin="1% 0">
              <GenericRow justify="flex-start">
                <GenericIcon margin="0 5px 0 0" src={Exclaimation} width="1.3rem" height="1.3rem" />
                <GenericTextSpan fSize={isMobile ? "1.2rem" : "1.2rem"}>
                  Jednorazowa płatność
                </GenericTextSpan>
              </GenericRow>
            </GenericColumn>
            <GenericColumn width={isMobile ? "100%" : "40%"} margin="1% 0">
              <GenericRow justify="flex-start">
                <GenericIcon margin="0 5px 0 0" src={Exclaimation} width="1.3rem" height="1.3rem" />
                <GenericTextSpan fSize={isMobile ? "1.2rem" : "1.2rem"}>
                  {`Dostęp na ${productData && productData.price && productData.price.extend_months} msc`}
                </GenericTextSpan>
              </GenericRow>
            </GenericColumn>
            <GenericColumn width={isMobile ? "100%" : "40%"} margin="1% 0">
              <GenericRow justify="flex-start" al>
                <GenericIcon margin="0 5px 0 0" src={Exclaimation} width="1.3rem" height="1.3rem" />
                <GenericTextSpan tAlign="left" fSize={isMobile ? "1.2rem" : "1.2rem"}>
                  Zamawiam z obowiązkiem zapłaty
                </GenericTextSpan>
              </GenericRow>
            </GenericColumn>
          </GenericRow>

          {/* Row 3: button row */}
          <GenericRow width="100%" margin="3% 0 0 0" justify="center">
            <GenericButton onClick={() => handleCreateStripeSession(location.state && location.state.productId)} width="50%" justify="center" className="standard">Zamów</GenericButton>
          </GenericRow>
        </PurchaseOptionBox>
      </GenericColumn>


    </GenericBackgroundLayer>
  )
}

export default ChallengePurchase
